import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hide-on-sm hide-on-print"},[_c(VRow,[_c(VCol,{attrs:{"md":"6"}},[_c(VBtn,{attrs:{"block":"","depressed":"","color":"primary"},on:{"click":_vm.search}},[_vm._v("\n        Search\n      ")])],1),_c(VCol,{attrs:{"md":"6"}},[_c(VBtn,{attrs:{"block":"","outlined":"","depressed":""},on:{"click":_vm.clear}},[_vm._v("Clear")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }